// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import { GlobalEvent, GlobalState } from './GlobalContext'
import MsgDialog from './MsgDialog';
import SelMemberDialog from './SelMemberDialog';
import SelectListDialog2 from './SelectListDialog2';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import EditIcon from '@mui/icons-material/Edit';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import GroupIcon from '@mui/icons-material/Group';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';


import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';




export default function FolderPermissionEditDialog(props) {

  const { sysID, open, onClose, folders, afterUpdate } = props;

  const folderID = (props.folderID == undefined ? DmsCommon.VOID_FOLDER_ID : props.folderID);
  const rights = props.rights || [];
  const inherited = (props.inherited === true) ? true : false;
  const inheritable = (props.inheritable === true) ? true : false;

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);

  const handleCloseClick = () => {
    // console.log("FolderPermissionEditDialog close");
    onClose && onClose();
  }

  const onCatchPromiseError = (e) => {
    gEventDispatch({
      showErr: true,
      err: e,
    });

  }

  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");


  const [openAddUserDialog, setOpenAddUserDialog] = useState(false);
  const [members, setMembers] = useState([]);
  const [groups, setGroups] = useState([]);

  const handleAddByUser = async () => {

    setShowLoading(true);

    try {

      const [vUsers, vGroups] = await Promise.all([
        DmsService.getMembersPromise(gState.sessionID, sysID, false),
        DmsService.getGroupsPromise(gState.sessionID, sysID),
      ]);

      // console.log('vUsers', vUsers);
      // console.log('vGroups', vGroups);

      setShowLoading(false);

      setMembers(vUsers);
      setGroups(vGroups);
      setOpenAddUserDialog(true);
    } catch (e) {
      setShowLoading(false);
      // setErrMsg(e.errMsg || e.message);
      // setShowError(true);
      onCatchPromiseError(e);
    }


  };



  const [modified, setModified] = useState(false);

  const [selectedRecs, setSelectedRecs] = useState([]);
  const [gridData, setGridData] = useState([]);

  useEffect(() => {
    // console.log("useEffect FolderPermissionEditDialog[open]");

    setGridData(rights);
    setIsInherited(inherited);
    setIsInheritable(inheritable);


    setModified(false);

  }, [open]);


  const [isInherited, setIsInherited] = useState(false);
  const [isInheritable, setIsInheritable] = useState(false);

  const handleIsInheritChange = (event) => {
    setIsInherited(event.target.checked);
    setModified(true);
  }

  const [resetPermission, setResetPermission] = useState(false);

  const handleResetPermissionChange = (event) => {
    setResetPermission(event.target.checked);
    setModified(true);
  }

  const onSelectionChanged = (params) => {
    // console.log('Selection Changed', params);
    let nodes = params.api.getSelectedNodes();
    // console.log('Selected nodes', nodes);

    let selRecs = nodes.map(item => {
      return item.data
    });

    setSelectedRecs(selRecs);

  }

  const handleSelectAddUsers = (aUsers, aGroups) => {
    // console.log("aUsers", aUsers);
    // console.log("aGroups", aGroups);

    setOpenAddUserDialog(false);

    let vData = gridData.map(item => {
      return item
    });

    let vHasUpdate = false;

    aUsers.forEach(addUser => {
      const vFound = vData.find(f => f.UserOrGroupID.toLowerCase() === addUser.UserID.toLowerCase());
      if (!vFound) {
        // console.log("addUser", addUser);
        const vNewItem = {
          "Dept": addUser.Department,
          "Grade": DmsCommon.AccessRightEnum.arReadDoc,
          "IsUser": true,
          "Name": addUser.FullName,
          // "NameForDisplay": addUser.FullName,
          "UserOrGroupID": addUser.UserID,
        }

        vData.push(vNewItem);

        vHasUpdate = true;
      }
    });

    aGroups.forEach(addGroup => {
      const vFound = vData.find(f => f.UserOrGroupID.toLowerCase() === addGroup.GroupID.toLowerCase());
      if (!vFound) {
        // console.log("addUser", addUser);
        const vNewItem = {
          "Dept": addGroup.Department,
          "Grade": DmsCommon.AccessRightEnum.arReadDoc,
          "IsUser": false,
          "Name": addGroup.Name,
          // "NameForDisplay": addGroup.GroupNameDisplay,
          "UserOrGroupID": addGroup.GroupID,
        }

        vData.push(vNewItem);

        vHasUpdate = true;
      }
    });

    // console.log("vData", vData);
    setGridData(vData);

    if (vHasUpdate) {
      setModified(true);
    }

  }

  const handleRemove = () => {
    // console.log("handleRemove selectedRecs", selectedRecs);

    const vData = gridData.filter(d => !selectedRecs.some(r => r.UserOrGroupID === d.UserOrGroupID));
    setGridData(vData);
    setSelectedRecs([]);

    setModified(true);
  }

  const handleSaveClick = async () => {
    // console.log("handleSaveClick", gridData);
    // console.log("handleSaveClick isInherited", isInherited);
    // console.log("handleSaveClick resetPermission", resetPermission);

    setShowLoading(true);
    try {

      const vPerms = gridData.map(item => {
        return { "userID": item.UserOrGroupID, "grade": item.Grade }
      });

      await DmsService.folderRightUpdatePromise(
        gState.sessionID, sysID, folderID, isInherited, resetPermission, vPerms, false);

      const xUpdateChildFolder = async (xParentFolderID) => {
        const xParentFolder = folders.find(f => f.id === xParentFolderID)
        // console.log('xUpdateChildFolder ~ xParentFolder:', xParentFolder)

        const folderChilds = folders.filter(f => f.ParentID === xParentFolderID)
        for (const f of folderChilds) {

          try {
            // console.log(`Update ChildFolder "${f.FolderPath}" `);
            await DmsService.folderChildRightUpdatePromise(
              gState.sessionID, sysID, f.id, resetPermission, false);
            // console.log("Success")

            await xUpdateChildFolder(f.id);

          } catch (e) {
            // console.log(`Fail: ${e.errMsg || e.message}`)
            // setErrMsg(e.errMsg || e.message);
            // setShowError(true);
            onCatchPromiseError(e);

          }

        }

      }

      await xUpdateChildFolder(folderID);

      setShowLoading(false);

      afterUpdate && afterUpdate();

    } catch (e) {
      setShowLoading(false);

      // setErrMsg(e.errMsg || e.message);
      // setShowError(true);
      onCatchPromiseError(e);

    }



  }

  const gradeOptions = Object.entries(DmsCommon.AccessRightEnum).map(([key, value]) => {
    return {
      "name": DmsCommon.AccessRightEnumToStr(value),
      "value": value,
    }
  })

  const handleSelectedGrade = (aValues) => {
    // console.log("handleSelectedAction", aValues);

    setOpenSelectGradeDialog(false);
    handleOptionChange(editingID, aValues);
  }

  const handleOptionChange = (aUserOrGroupID, aNewValue) => {
    // console.log("handleOptionChange", aUserOrGroupID, aNewValue);

    const vData = gridData.map(item => {

      if (item.UserOrGroupID == aUserOrGroupID) {
        return {
          ...item,
          Grade: aNewValue
        }
      } else {
        return item
      }
    })

    setGridData(vData);
    setSelectedRecs([]);

    setModified(true);
  };

  const [editingID, setEditingID] = useState("");
  const [editingGrade, setEditingGrade] = useState(0);
  const [openSelectGradeDialog, setOpenSelectGradeDialog] = useState(false);

  const handleActionBtnClick = (aUserOrGroupID, aGrade) => {
    // console.log("handleActionBtnClick", aUserOrGroupID, aGrade);

    setEditingID(aUserOrGroupID);
    setEditingGrade(aGrade);
    setOpenSelectGradeDialog(true);
  }


  const GradeCellRenderer = (params) => {
    // console.log("GradeCellRenderer", params);

    const vUserOrGroupID = params.data.UserOrGroupID;
    const vGrade = params.value;
    const vGradeDesc = DmsCommon.AccessRightEnumToStr(vGrade);

    return (
      <Box component="div" sx={{ p: 0, flexGlow: 1 }}>
        <Button
          color="primary"
          size="small"
          startIcon={<EditIcon />}
          onClick={() => handleActionBtnClick(vUserOrGroupID, vGrade)}
          fullWidth
          disableRipple >
          {vGradeDesc}
        </Button>
      </Box>

    );
  };



  const cellStyle = { paddingLeft: '10px', paddingRight: '10px', fontSize: '0.8rem' };

  const UserTypeRenderer = (params) => {
    return (

      <IconButton color="primary" aria-label="upload picture" component="span">
        {params.value === true && <AccountCircleIcon />}
        {params.value !== true && <GroupIcon />}
      </IconButton>
    )
  }

  const compareStrInsensitive = (aStrA, aStrB) => {
    return aStrA.localeCompare(aStrB, undefined, { sensitivity: "base" })
  }

  const comparatorName = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.Name, nodeB.data.Name)
  }

  const columnDefs = useMemo(() => [
    { field: 'IsUser', headerName: " ", cellStyle: cellStyle, width: 50, cellRenderer: UserTypeRenderer, },
    {
      field: 'Name', headerName: "Group/User Name", cellStyle: cellStyle, minWidth: 150, flex: "1",
      headerCheckboxSelection: true, checkboxSelection: true, comparator: comparatorName,
    },
    { field: 'Grade', headerName: "Access Right", cellStyle: cellStyle, minWidth: 150, flex: "1", cellRenderer: GradeCellRenderer, },
  ], []);

  const handleGetRowId = useCallback((params) => params.data.UserOrGroupID, []);

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"sm"}
      aria-describedby="folder-permission-edit-dialog"
    >
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MsgDialog
        open={showError}
        title="Error"
        msgText={errMsg}
        onClose={() => setShowError(false)}
      />

      <SelMemberDialog
        open={openAddUserDialog}
        onClose={() => { setOpenAddUserDialog(false) }}
        members={members}
        groups={groups}
        onSelect={handleSelectAddUsers}
      />

      <SelectListDialog2
        open={openSelectGradeDialog}
        selectLabel="Access Right"
        iniValue={editingGrade}
        options={gradeOptions}
        onSelected={handleSelectedGrade}
        onClose={() => setOpenSelectGradeDialog(false)}
      />

      <DialogTitle id="alert-dialog-title">
        Folder Permissions
      </DialogTitle>
      <DialogContent>

        <Box sx={{ display: 'flex', flexDirection: 'column', height: "70vh" }} >


          <Box sx={{ py: 1, px: 1 }} >
            {isInheritable &&
              <FormControlLabel control={<Checkbox checked={isInherited} onChange={handleIsInheritChange} />} label="Inherit permissions from parent folder" />
            }
            <FormControlLabel control={<Checkbox checked={resetPermission} onChange={handleResetPermissionChange} />} label="Reset permissions on all child folders" />
          </Box>


          <Box sx={{ py: 1, px: 1, display: isInherited ? "none" : "block" }} >
            <Button
              id="add-button"
              startIcon={<PersonAddAlt1Icon />}
              onClick={handleAddByUser}
            >
              Add
            </Button>

            <Button startIcon={<PersonRemoveIcon />} disabled={selectedRecs.length == 0} onClick={handleRemove}>
              Remove
            </Button>

          </Box>


          <div className="ag-theme-material" style={{ display: isInherited ? "none" : "block", width: '100%', height: '100%', bgcolor: 'yellow' }}>
            <AgGridReact

              rowData={gridData}

              defaultColDef={{
                width: 100,
                resizable: true,
                sortable: true,
                suppressMovable: true,
              }}
              columnDefs={columnDefs}
              headerHeight={40}

              suppressNoRowsOverlay

              rowSelection="multiple"
              rowMultiSelectWithClick

              onSelectionChanged={onSelectionChanged}

              getRowId={handleGetRowId}

            >

            </AgGridReact>

          </div>




        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick}>Cancel</Button>
        <Button disabled={!modified} variant="contained" startIcon={<SaveIcon />} onClick={handleSaveClick} >
          Save
        </Button>
      </DialogActions>
    </Dialog>

  );
}

FolderPermissionEditDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  sysID: PropTypes.string,
  folders: PropTypes.array,
  folderID: PropTypes.number,
  rights: PropTypes.array,
  inherited: PropTypes.bool,
  inheritable: PropTypes.bool,
  afterUpdate: PropTypes.func,
};
